import { useCallback } from "react";
import { useIntl } from "react-intl";
import type { Region } from "src/shared/objects/Region";

export const useGetRegionName = () => {
  const { locale } = useIntl();
  return useCallback(
    (region: Region) => region[`regionName${locale.toUpperCase()}`] ?? locale,
    [locale],
  );
};
